import { useRef, useEffect, useState } from 'react';
import { Link, useNavigate } from "react-router-dom";
import { Navigate } from 'react-router-dom';
import axios from 'axios';
import qs from 'qs';
import { ToastContainer, toast } from "react-toastify";
import { toastSuccess, toastError } from '../utils/Alerts'

const CACModal = () => {

    const [accessToken, setAccessToken] = useState("")

    const [verificationStatus, setVerificationStatus] = useState("")
    const [companyDetail, setCompanyDetail] = useState("")
    const [rcNumber, setRCNumber] = useState("")
    const [cacCheckPending, setCacCheckPending] = useState(false)
    const [cacCheckStatus, setCacCheckStatus] = useState(false)

    const navigate = useNavigate()

    let companyData

    const handleCACVerification = () => {
        setCacCheckPending(true)
        //get auth token
        const username = '654e61e419e1f9001cb85ff6';
        const password = 'CIO5KWKMU2TI5WMJMNDVRGVDH3LVEFZA';

        const credentials = btoa(`${username}:${password}`);
        const authHeader = `Basic ${credentials}`;

        const apiUrl = 'https://api.getmati.com/oauth'; // Replace with your API endpoint
        const verificationUrl = ''

        const data = {
            grant_type: 'client_credentials',
            username: username,
            password: password,
        };

        axios.post(apiUrl, qs.stringify(data), {
            headers: {
                'Authorization': authHeader,
                'Content-Type': 'application/x-www-form-urlencoded',
                // Add other headers as needed
            },
        })
            .then(response => {
                // Handle the response
                console.log(response.data.access_token);
                setAccessToken(response.data.access_token)
                const rToken = response.data.access_token

                console.log("API Security token successfully generated")

                //make second axios request to create verification record.
                axios.post('https://onboarding.norrenberger.com/onboarding/create-verification-record',
                    {
                        "rcNumber": rcNumber,
                        "requestId": rcNumber
                    }
                )
                    .then((response) => {
                        console.log(response.data)
                        console.log("Request record successfully created")
                        // make third request this time to get mati endpoint to send the data and update the database table.
                        axios.post('https://api.getmati.com/govchecks/v1/ng/cac',
                            {
                                "registrationNumber": rcNumber,
                                // "callbackUrl": "https://webhook.site/057a9fd5-5c10-476f-a420-37792d57c4b5"
                                "callbackUrl": "https://onboarding.norrenberger.com/onboarding/verify-record"
                            },
                            {
                                headers: {
                                    'Authorization': `Bearer ${rToken}`,
                                    'Content-Type': 'application/json',
                                },
                            })
                            .then((response) => {
                                console.log(response.status)
                                console.log("cac check completed waiting for metamap...checking database for record status")
                                // run periodic checks to determine if record is found in database. run 10 checks with 10 second intervals.

                                setTimeout(() => {
                                    axios.post('https://onboarding.norrenberger.com/onboarding/check-record',
                                        {
                                            "cacNumber": rcNumber,
                                        })
                                        .then((response) => {
                                            console.log(response.data)
                                            console.log("finished checking for record in db")
                                            if (response.data.msg === "record found") {
                                                console.log("record found")
                                                companyData = response.data.existingRecord
                                                setCompanyDetail(companyData.companyName)

                                                console.log(companyData.companyName)
                                                setVerificationStatus("passed")
                                                toastSuccess("cac record found for RC-"+rcNumber)
                                            }
                                            else if(response.data.msg === "record not found") {
                                                console.log("cac not found")
                                                toastError("cac record not found for RC-"+rcNumber)
                                            }
                                            else if(response.data.msg === "cac unavailable") {
                                                console.log("CAC Unavailable")
                                                toastError("Sorry we are unable to verify your information at this time. Please try again later.")
                                            }
                                            setCacCheckPending(false)
                                        })
                                        .catch((error) => {
                                            console.log("check record error" + error)
                                        })
                                }, 30000)

                            })
                            .catch((error) => {
                                console.log("get mati error" + error)
                            })
                    })
                    .catch((error) => {
                        console.log("create verification error: " + error)
                    })


            })
            .catch(error => {
                // Handle errors
                console.error('Error:', error);
                setCacCheckPending(false)

            })
    }


    // const handleCACVerification = () => {
    //     setCacCheckPending(true)
    //     //get auth token

    //     const token = "eyJhbGciOiJIUzI1NiJ9.eyJpc3MiOiJodHRwczovL2FwaS5hcHBydXZlLmNvIiwianRpIjoiOWI5N2E3OTUtZWU5OC00NWU0LWI3ZWQtOTFlNjIzYjYzMzcxIiwiYXVkIjoiZGNiNjAyMWMtYzNhOS00MDFjLTk0OTgtMmMxNjdkOTBhNWRjIiwic3ViIjoiMzY4ZTg0ZDMtM2VmYy00MDQ3LWEwMTYtZGUxNTU4MjUxYjJiIiwibmJmIjowLCJzY29wZXMiOlsidmVyaWZpY2F0aW9uX3ZpZXciLCJ2ZXJpZmljYXRpb25fbGlzdCIsInZlcmlmaWNhdGlvbl9kb2N1bWVudCIsInZlcmlmaWNhdGlvbl9pZGVudGl0eSJdLCJleHAiOjE3MDU1OTAxNzEsImlhdCI6MTcwMjk5ODE3MX0.x57IJS4bIg6w_K8y--jTPbRXW0Atv8bQrqRm6dNTktA"

    //     axios.post("https://api.appruve.co/v1/verifications/ng/business_info",
    //         {
    //             "search_term": rcNumber,
    //         },
    //         {
    //             headers: {
    //                 'Authorization': `Bearer ${token}`,
    //                 'Content-Type': 'application/json',
    //             },

    //         })
    //         .then(response => {
    //             // Handle the response
    //             console.log(response.status);
    //             console.log(response.data)

    //             // const problem = response.data.hasProblem
    //             if (response.data.message === true) {
    //                 toast.error("No company was found with that RC Number", {
    //                     position: "top-right",
    //                     autoClose: 3000,
    //                     hideProgressBar: false,
    //                     closeOnClick: true,
    //                     pauseOnHover: true,
    //                     draggable: true,
    //                     progress: undefined,
    //                     theme: "light",
    //                 });
    //             }
    //             else if (!response.data.message) {
    //                 const companyName = response.data.company_name
    //                 toast.success("Your CAC Verification was successful and your company " + companyName + " is verified", {
    //                     position: "top-right",
    //                     autoClose: 3000,
    //                     hideProgressBar: false,
    //                     closeOnClick: true,
    //                     pauseOnHover: true,
    //                     draggable: true,
    //                     progress: undefined,
    //                     theme: "light",
    //                 });

    //                 // console.log(bvn+" "+firstname+" "+lastname)
    //                 console.log('successful')
    //             }

    //         })
    //         .catch(error => {
    //             // Handle errors
    //             console.error('Error:', error);
    //             toast.error("No company was found with that RC Number", {
    //                 position: "top-right",
    //                 autoClose: 3000,
    //                 hideProgressBar: false,
    //                 closeOnClick: true,
    //                 pauseOnHover: true,
    //                 draggable: true,
    //                 progress: undefined,
    //                 theme: "light",
    //             });

    //         })
    //         .finally(() => {
    //             console.log("verification completed")
    //             setCacCheckPending(false)
    //         })
    // }


    return (
        <div className="modal fade" id="cac-verification">
            <div className="modal-dialog modal-sm">
                <div className="modal-content radius-3">

                    {/* <!-- Modal Header --> */}
                    <div className="modal-header">
                        <h6 className="modal-title"><i className="bi-shield me-2"></i> CAC Verification</h6>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={()=>setVerificationStatus("")}></button>
                    </div>

                    {/* <!-- Modal body --> */}
                    <div className="modal-body">
                        <div className="">
                            {
                                cacCheckPending ? (
                                    <>
                                        <div className="text-center">
                                            <div class="spinner-border spinner-border text-custom"></div>
                                            <p className="bold text-small">Verifying your Company Information.. This may take a while. Please do not leave this page.</p>
                                        </div>
                                    </>
                                ) : (
                                    <>
                                        {
                                            verificationStatus === "passed" ? (
                                                // <>
                                                //     <div className="text-center">
                                                //         <h3 style={{ marginBottom: "-10px" }}><i className="bi-buildings text-muted"></i></h3>
                                                //         <small className="text-small bold text-muted">Company Verified <i className="bi-check-circle-fill text-success"></i></small>
                                                //         <p className="p-1 text-small bold">{companyDetail || "Loading company information"}</p>
                                                //         <button className="btn-custom" data-bs-dismiss="modal" onClick={() => {
                                                //             setVerificationStatus("")
                                                //             navigate("/products")
                                                //         }}>Continue to Products<i className='bi-chevron-right ms-2'></i></button>
                                                //     </div>
                                                // </>
                                                <>
                                                <div className="text-center">
                                                    <h3 style={{ marginBottom: "-10px" }}><i className="bi-buildings text-muted"></i></h3>
                                                    <small className="text-small bold text-muted">Company Verified <i className="bi-check-circle-fill text-success"></i></small>
                                                    <p className="p-1 text-small bold">{companyDetail || "Loading company information"}</p>
                                                    <button className="btn-custom" data-bs-dismiss="modal" onClick={() => {
                                                        setVerificationStatus("")
                                                        navigate("/new-corporate-account")
                                                    }}>Continue<i className='bi-chevron-right ms-2'></i></button>
                                                </div>
                                            </>
                                            ) : (
                                                <form onSubmit={handleCACVerification} enctype="multipart/form-data">
                                                    <div className="row">
                                                        <div className="">
                                                            <label for="rcnumber" className="small bold">Enter Company RC Number</label>
                                                            <input type="number" className="form-control custom-input" value={rcNumber} onChange={(e) => setRCNumber(e.target.value)} />
                                                        </div>
                                                    </div>
                                                    <button className="btn-custom w-100 my-3" type="submit" >Continue <i className="bi bi-arrow-right mt-1"></i></button>
                                                    <div className="p-2 bg-silver-gradient" style={{ fontSize: "10px" }}>
                                                        <i className="bi-info-circle-fill"></i> Your verification details are kept secure and confidential. We prioritize data protection and will not share your information.
                                                    </div>
                                                </form>

                                            )
                                        }

                                    </>
                                )
                            }

                        </div>
                    </div>

                </div>
            </div>
        </div>
    )
}

export default CACModal